import tokens from '@ifood/pomodoro-tokens';
import React from 'react';
import styled from 'styled-components';

import { CallOutKind } from '../../types';

type PropTypes = {
  children: React.ReactNode;
  kind: CallOutKind;
};

const colors: Record<CallOutKind, [string, string]> = {
  [CallOutKind.INFO]: ['#e3edf2', '#5bc0de'],
  [CallOutKind.WARNING]: ['#fcf8f2', '#f0ad4e'],
  [CallOutKind.ATTENTION]: ['#fdf7f7', '#d9534f'],
  [CallOutKind.RECOMMENDATION]: ['#f3f8f3', '#50af51'],
};

const buildStyles = ([light, dark]: [string, string] = colors.attention): string => `
  background-color: ${light};
  border-color: ${dark};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${dark};
  }
`;

const CallOut = styled.div<PropTypes>`
  border-left: ${tokens.space.smallest} solid;
  padding: 13px 8px 1px 46px;
  max-width: 610px;
  box-sizing: border-box;
  margin-bottom: 11px;

  ${({ kind }): string => buildStyles(colors[kind])};
`;

export default CallOut;
